import { Tabs, theme } from "antd";
import { Work, WorkComponent } from "../Work";
import { EntityWorkContext } from "../useEntityWork";
import React from "react";
import { Section } from "./Section";

export type TabbedWorkItems = {
  name: string;
  aggregate?: boolean;
  setHasResults?: (hasResults: boolean) => void;
  search: Omit<EntityWorkContext, "dataRef" | "setPagination" | "query">;
};

export const useTabbedItems = (
  items: TabbedWorkItems[],
  setHasResultsCallback: (val: boolean) => void
) => {
  return items.map((item) => {
    return {
      key: item.name,
      label: item.name,
      children: (
        <SearchResults
          search={item}
          hasResultsCallback={setHasResultsCallback}
        />
      ),
    };
  });
};

export function TabbedWork(props: {
  title?: string;
  items: TabbedWorkItems[];
}) {
  const { token } = theme.useToken();
  const [hasResults, setHasResults] = React.useState(true);
  const setHasResultsCallback = (hasResults: boolean) =>
    setHasResults(hasResults);
  const items = useTabbedItems(props.items, setHasResultsCallback);
  return (
    <>
      {hasResults ? (
        <Tabs
          className="compact-tabs"
          tabBarExtraContent={
            props.title
              ? {
                  left: <div className="section-header">{props.title}</div>,
                }
              : undefined
          }
          defaultActiveKey="1"
          items={items}
          tabBarGutter={16}
          style={{ margin: 0, padding: 0 }}
        />
      ) : (
        <>
          <Section
            title={props.title}
            isEmpty={true}
            style={{ paddingTop: 0 }}
          />
          <Section style={{ color: token.colorTextTertiary, paddingTop: 0 }}>
            None
          </Section>
        </>
      )}
    </>
  );
}

function SearchResults(props: {
  search: TabbedWorkItems;
  hasResultsCallback: (val: boolean) => void;
}) {
  return (
    <div className="compact-table clickable-rows">
      <Work
        orgId={props.search.search.orgId}
        search={props.search.search.search}
        entityUuid={props.search.search.entityUuid}
        actorUuid={props.search.search.actorUuid}
        types={props.search.search.types}
        pagingSize={props.search.search.pagingSize}
      >
        <WorkComponent
          aggregate={props.search.aggregate}
          hasResultsCallback={props.hasResultsCallback}
        />
      </Work>
    </div>
  );
}
